import { useState, useEffect } from 'react';

const STORAGE_KEY = 'samsung-dark-mode-banner-dismissed';

function isSamsungBrowser(): boolean {
  return /SamsungBrowser/i.test(navigator.userAgent);
}

export function SamsungBrowserBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    const isSamsung = isSamsungBrowser();

    // Show for all Samsung Internet users - their forced dark mode
    // doesn't report via prefers-color-scheme so we can't detect it
    if (!dismissed && isSamsung) {
      setShow(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="border-b border-amber-300 bg-amber-100 px-4 py-3 text-sm text-amber-900">
      <div className="flex items-start justify-between gap-3">
        <div>
          {/* <p className="font-semibold">Colors look wrong?</p> */}
          <p className="font-semibold">
            This site employs features that must be viewed in ‘Light’ Mode. Please change your settings.
          </p>
          <p className="mt-1">
            Tap the <strong>☰ menu</strong> (bottom-right) and select <strong>&ldquo;Light sites&rdquo;</strong> to fix.
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="shrink-0 text-lg leading-none font-bold text-amber-700 hover:text-amber-900"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
